module.exports = __webpack_public_path__ + "img/Divina Massa - Post Instagram.c6792899.png";